import { enumXMLType } from "../constants";
import { XML_DrawImagePPT } from "./XML_DrawImagePPT";
import { XML_DrawImagePDF } from "./XML_DrawImagePDF";

export function XML_DrawImage(
  x,
  y,
  width,
  height,
  clipRect,
  pictureMask,
  cell,
  drawElement,
  layer,
  linecolor,
  isIcon = false
) {
  var docType = drawElement.GetDocType();

  if (docType == enumXMLType.PDF)
    XML_DrawImagePDF(
      x,
      y,
      width,
      height,
      clipRect,
      pictureMask,
      cell,
      drawElement,
      layer,
      linecolor,
      isIcon
    );
  else {
    XML_DrawImagePPT(
      x,
      y,
      width,
      height,
      clipRect,
      pictureMask,
      cell,
      drawElement,
      layer,
      linecolor,
      isIcon
    );
  }
}
